import primaryPages from './pages-primary.json';
import specialtyPages from './pages-specialty.json';
import guidePages from './pages-guides.json';
import utilityPages from './pages-utility.json';
import routeAliases from './route-aliases.json';
import type { PageContent } from '../types/pageContent';
import { images } from './site';

const realCoreImages: Record<string, PageContent['image']> = {
  'semi-truck-body-repair': { src: images.hood, alt: 'White commercial truck hood inside the workshop', caption: 'Commercial truck hood in the shop', objectPosition: '50% 45%' },
  'box-truck-body-repair': { src: images.boxTruck, alt: 'Open box truck side wall structure with a technician at work', caption: 'Box truck body repairs in the shop', objectPosition: '50% 50%' },
  'fleet-truck-body-repair': { src: images.workTruck, alt: 'Red-striped commercial work truck carrying equipment on its bed', caption: 'Commercial work truck with equipment on the bed', objectPosition: '50% 55%' },
};
export const pages = ([...primaryPages, ...specialtyPages, ...guidePages, ...utilityPages] as PageContent[])
  .map(page => page.image || !realCoreImages[page.id] ? page : { ...page, image: realCoreImages[page.id] });
export const pagesByPath = new Map(pages.map(page => [page.path, page]));
export const pagesById = new Map(pages.map(page => [page.id, page]));
export const aliasPaths: Record<string, string> = {};
for (const page of pages) {
  for (const alias of page.existingAliases || []) aliasPaths[alias] = page.path;
}
// The reconciled CMS/public map takes precedence over a content draft's aliases.
Object.assign(aliasPaths, routeAliases as Record<string, string>);

export const servicePages = pages.filter(page => page.kind === 'service');
export const guideContentPages = pages.filter(page => page.kind === 'guide');
